var config = {
  root_host: "https://travel.zdapk.cn/",
  /* #ifdef H5 */
  root_host: "/Api/",
  /* #endif */
  version: "1.0.0",
  app_id: "kidstopia",
  wx_app_id: "1f8u4sa9123ns80",
  aes_key: "8UJan%^&1^G4KIUJ"
};
export { config };



// WEBPACK FOOTER //
// ./src/utils/config.js